module.exports = __webpack_public_path__ + "components/MapControl/svg/Wiata turystyczna.svg?853aba6e";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Wiata turystyczna.svg
// module id = 2046
// module chunks = 0